import React from 'react'
import Navigation from './navigation'
import { Link } from 'gatsby'
import { useMenuQuery } from '../queries/static'
import NavigationDropdown from './navigation-dropdown'
import Logo from './logo'
import { motion, AnimatePresence } from 'framer-motion'

interface Props {
  isOpen: boolean
  setIsOpen: (boolean) => void
  activeMenu: string
  setActiveMenu: (string) => void
}

const Header: React.FC<Props> = ({ isOpen, setIsOpen, activeMenu = '', setActiveMenu }) => {
  const data = useMenuQuery()

  return (
    <header className='header bg-white z-20 sticky top-0'>
      <div className='header__content flex items-center max-w-screen-2xl mx-auto px-12 z-20'>
        <div className='hidden lg:block'>
          <Link aria-label='Home' to='/'>
            <Logo />
          </Link>
        </div>
        <div className='lg:hidden'>
          <Link to='/'>
            <Logo size='small' />
            <span className='sr-only'>Marketware</span>
          </Link>
        </div>
        <Navigation
          data={data}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
        />
      </div>
      <AnimatePresence mode='wait'>
        {isOpen && (
          <motion.div
            key='nav'
            initial={{ opacity: 0, y: -200, z: -1 }}
            animate={{ opacity: 1, y: 0, z: 0 }}
            transition={{ ease: 'anticipate', duration: 0.35 }}
            exit={{ opacity: 0, y: -100, z: -1 }}
            className='z-20'
          >
            <NavigationDropdown
              data={data}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              activeMenu={activeMenu}
              setActiveMenu={setActiveMenu}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  )
}

export default Header
